<template>
  <div>
    <div class="container">
      <div class="row scroll">
        <div class="col-md-12 col-xs-12 hidden-xs hidden-sm">
          <div id="image-slider-desktop" class="splide">
            <div class="splide__track">
              <ul class="splide__list">
                <li class="splide__slide" v-for="(repeat, index) in repeats" :key="'repeatable-' + index">
                  <div class="card">
                    <img class="card-image"
                         :src="repeat['iconimage']">
                    <div class="card-body">
                      <p v-html="repeat['text']">
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <a :href="non_repeat.buttonlink" class="btn btn-primary secbutton alignment-button" id="benefit-button">
              {{ non_repeat.buttontext }}
            </a>
            <div class="splide__arrows">
              <button class="splide__arrow splide__arrow--prev" id="prev">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                  <path
                    d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                  </path>
                </svg>
              </button>
              <div class="text-arrow">
                <span id="splide-index-desktop"></span> von <span id="splide-length-desktop"></span>
              </div>
              <button class="splide__arrow splide__arrow--next" id="next">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                  <path
                    d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                  </path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 visible-xs visible-sm">
          <div id="image-slider-mob" class="splide">
            <div class="splide__track">
              <ul class="splide__list">
                <li class="splide__slide" v-for="(repeat, index) in repeats" :key="'repeatable-' + index">
                  <div class="card">
                    <img class="card-image"
                         :src="repeat['iconimage']">
                    <div class="card-body">
                      <p v-html="repeat['text']">
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="splide__arrows display-arrow">
              <button class="splide__arrow splide__arrow--prev">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                  <path
                      d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                  </path>
                </svg>
              </button>
              <div class="text-arrow">
                <span id="splide-index-mob"></span> von <span id="splide-length-mob"></span>
              </div>
              <button class="splide__arrow splide__arrow--next">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                  <path
                      d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                  </path>
                </svg>
              </button>
            </div>
          </div>
            <a :href="non_repeat.buttonlink" class="btn btn-primary secbutton">{{ non_repeat.buttontext }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'benefitSection',
  props: ['repeats', 'non_repeat'],
}
</script>

<style scoped lang="scss">

@import "../../css/variables.scss";
p{
  color:$color-jungle-green;
}
.splide__arrows {
  color: $color-jungle-green;
}
.scroll {
  overflow-x: hidden;
}

.container {
  padding: 0;
}

ul {
  list-style-type: none;
}

.card {
  position: relative;
  margin-top: 30px;
}

.card-image {
  max-width: 3em;
  margin-left: 6%;
  margin-bottom: -5%;
}

.card-body {
  border: 2px solid white;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 2px 10px 8px 2px #dddddd;
  margin-bottom: 30px;
  height: 168px;
}

.display-arrow {
  display: flex;
  justify-content: flex-start;
  column-gap: 15px;
  padding-left: 35px;
}

.splide__arrow {
  border: 1px solid $color-jungle-green;
  border-radius: 0;
  width: 54px;
  height: 54px;
  position: relative;
  margin: 0;
  background: #FFFFFF;
  top: 0;
  left: 0;
  transform: none;
}

.text-arrow {
  position: relative;
  left: 0;
  top: 0;
  margin: 0;
  font-weight: bold;
  font-size: 12px;
  align-self: center;
}
.secbutton {
  margin-left: 0;
  font-size: 16px;
  width: 263px;
  height: 54px;
  padding-top: 12px;
  background-color: $color-jungle-green;
  color: $color-white;
  &:hover, &:active, &:focus {
    background-color: $color-jungle-green-button-hover;
    color: $color-white;
    border-color: $color-fling-green;
  }
}
.splide__track{
  overflow: visible;
}

.splide__arrows {
  display: flex;
  column-gap: 15px;

  @media (min-width: $md-breakpoint-min) {
    margin-right: 135px;
    justify-content: flex-end;
    margin-top: -54px;
  }
}

@media (min-width:1025px) and (max-width: 1199px){
  .card-body{
    width: 222px;
    height: 190px;
  }
}
@media (min-width:$md-breakpoint-min) and (max-width: 1024px){
  .card-body{
    width: 220px;
    height: 206px;
  }
}
@media  (min-width: 757px) and (max-width: $md-breakpoint-max) {
  .secbutton {
    margin-top: 35px;
  }

  .card-body{
    width: 220px;
    margin-left: 26px;
  }
  .splide {
    padding-top: 0;
    padding-right: 52%;
  }
}
@media  (min-width: 569px) and (max-width: 756px){
  .secbutton {
    margin-top: 35px;
  }

  .card-body{
    margin-left: 26px;
  }
}
@media (max-width: $xs-breakpoint-max){
  .secbutton {
    margin-top: 35px;
    width: 100%
  }

  .card-body {
    width: 95%;
    height: 206px;
  }
}

@media (max-width: 400px) {
  .card-image{
    margin-left: 15%;
  }
}

@media (min-width: 1024px) {
  .splide__track {
    margin-left: 42px;
  }
  .alignment-button {
    margin-left: 55px;
  }
}
@media (min-width: 1920px) {
  .splide__track {
    margin-left: 75px;
  }
  .alignment-button {
    margin-left: 84px;
  }
}
</style>
